import React from "react";
import { Link } from "react-router-dom";
import '../../styles/FooterStyles.css';

const Footer = () => {
  return (
    <div className="container-fluid footer-container gradient-bg">
      <footer className="py-5"> {/* Incrementamos el padding */}
        <div className="row">
          {/* Columna de información principal */}
          <div className="col-12 col-md-3 mb-4 text-center">
            <img
              src="/images/userImages/Logo.png" // Cambia esta ruta por el logo real
              alt="Logo Constructora Cantabria"
              className="footer-logo mb-2"
              style={{ width: "200px", height: "auto" }}
            />
            <p className="text-secondary">
              Trabajamos para construir tus sueños con proyectos únicos y de
              alta calidad.
            </p>
          </div>

          {/* Columna "Trabaja con nosotros" */}
          <div className="col-6 col-md-3 mb-3">
            <h5>Trabaja con nosotros</h5>
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <Link to="/about" className="nav-link p-0 text-secondary">
                  Quiénes somos
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link to="/careers" className="nav-link p-0 text-secondary">
                  Únete a nuestro equipo
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna "Proyectos y Propiedades" */}
          <div className="col-6 col-md-3 mb-3">
            <h5>Explora</h5>
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <Link to="/projects" className="nav-link p-0 text-secondary">
                  Nuestros Proyectos
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link to="/properties" className="nav-link p-0 text-secondary">
                  Propiedades Disponibles
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link to="/privacy" className="nav-link p-0 text-secondary">
                  Avisos de privacidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna "Atención al cliente" */}
          <div className="col-6 col-md-3 mb-3">
            <h5>Atención al cliente</h5>
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <Link to="/contact" className="nav-link p-0 text-secondary">
                  Contáctanos
                </Link>
              </li>
              <li className="nav-item mb-2">
                <a
                  href="tel:018000180899"
                  className="nav-link p-0 text-secondary"
                >
                  Línea nacional: 018000180899
                </a>
              </li>
              <li className="nav-item mb-2">
                <Link to="/terms" className="nav-link p-0 text-secondary">
                  Términos y condiciones
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="d-flex justify-content-center py-3 my-2 border-top">
          <p className="text-center text-secondary m-0">
            Constructora Cantabria © 2024. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
